<template>
  <div class="about-page">
    <!-- 平台介绍 -->
    <section class="section intro">
      <h1>平台介绍</h1>
      <p>
        我们是一个专业的源码展示平台，致力于为广大开发者提供高质量的源码项目。平台汇集了各种类型的源码项目，包括 Web 应用、移动应用、桌面应用等，帮助开发者快速找到所需的源码资源，提升开发效率。
      </p>
    </section>

    <!-- 服务特色 -->
    <section class="section features">
      <h1>服务特色</h1>
      <div class="features-grid">
        <div class="feature-card">
          <h3>精选源码</h3>
          <p>严格筛选，只展示高质量的源码项目</p>
        </div>
        <div class="feature-card">
          <h3>详细说明</h3>
          <p>每个项目都有详细的介绍和使用说明</p>
        </div>
        <div class="feature-card">
          <h3>技术支持</h3>
          <p>提供专业的技术支持和售后服务</p>
        </div>
        <div class="feature-card">
          <h3>持续更新</h3>
          <p>定期更新源码项目，保持内容新鲜</p>
        </div>
      </div>
    </section>

    <!-- 修改后的售后保障模块 -->
    <section class="section contact">
      <h1>售后保障</h1>
      <p>我们承诺为每一位客户提供优质、贴心的售后服务</p>
      <div class="contact-cards">
        <div class="contact-card">
          <div class="icon">🕒</div>
          <p>7×24小时在线支持</p>
        </div>
        <div class="contact-card">
          <div class="icon">💻</div>
          <p>远程协助与问题解决</p>
        </div>
        <div class="contact-card">
          <div class="icon">🐞</div>
          <p>免费BUG修复</p>
        </div>
        <div class="contact-card">
          <div class="icon">🔄</div>
          <p>版本升级与优化</p>
        </div>
        <div class="contact-card">
          <div class="icon">🎓</div>
          <p>专业指导与解疑</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: "AboutPage",
}
</script>

<style scoped>
.about-page {
  padding: 40px 10%;
  font-family: 'Microsoft YaHei', sans-serif;
  color: #333;
  line-height: 1.6;
}

.section {
  margin-bottom: 50px;
}

.section h1 {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #5c4ff0;
  border-left: 5px solid #5c4ff0;
  padding-left: 10px;
}

.section p {
  font-size: 16px;
  color: #555;
}

/* 服务特色卡片 */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.feature-card {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s, box-shadow 0.3s;
}

.feature-card h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #863bcd;
}

.feature-card p {
  font-size: 14px;
  color: #434245;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
}

/* 新售后保障样式 */
.contact p {
  font-size: 16px;
  margin-bottom: 20px;
  color: #faf6f6;
}

.contact-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
}

.contact-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 20px;
  background: linear-gradient(135deg, #863bcd, #3731e4); /* 渐变色 */
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  transition: transform 0.3s, box-shadow 0.3s;
  color: #fff;
  font-weight: 500;
}

.contact-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.18);
}

.contact-card .icon {
  font-size: 28px;
}
/* 响应式 */
@media (max-width: 768px) {
  .about-page {
    padding: 30px 5%;
  }

  .section h1 {
    font-size: 24px;
  }

  .feature-card h3 {
    font-size: 16px;
  }

  .feature-card p {
    font-size: 13px;
  }

  .contact-cards {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  }

  .contact-card {
    font-size: 14px;
    padding: 12px 15px;
  }

  .contact-card .icon {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AboutPage.vue